import PlainText from 'components/atoms/PlainText';
import { BulletList } from 'components/atoms';
import { Spinner } from 'components/atoms';
import { TextInput, NumberInput, DoubleNumberInput } from 'components/molecules';
import Button from 'components/molecules/Button';
import { UnitSwitch } from 'components/molecules';
import {MuiDimensionInput as DimensionInput, MuiPositionInput as PositionInput, MuiRangeInput as RangeInput} from 'components/molecules/DimensionInput';
import { MuiSelectButtons as SelectButtons, MuiToggleButtons as ToggleButtons, MuiToggleSelect as ToggleSelect, MuiFamilyButtons as FamilyButtons } from 'components/molecules/ButtonGroup';
import RadioButtons from 'components/molecules/RadioButtons';
import TabNavigation from 'components/molecules/TabNavigation';
import { MeasurementInput } from 'components/molecules';
import { Slider } from 'components/atoms';
import MuiSelector from 'components/molecules/Selector';
import SpeakerMountingSelector from 'components/molecules/SpeakerMountingSelector';
import SpeakerLinkToggle from 'components/molecules/SpeakerLinkToggle';
import SpeakerModelSelector from 'components/molecules/SpeakerModelSelector';
import PlotTypeSelector from 'components/molecules/PlotTypeSelector';
import { CheckBox } from 'components/molecules';
import { ErrorContent, ValueContent } from 'components/molecules';
import MuiCarousel from 'components/organisms/Carousel';
import MuiVideo from 'components/organisms/Video';
import { Output } from 'components/molecules';
import { Fader } from 'components/atoms';
import QuoteForm from 'components/atoms/QuoteForm';
import QuoteFormWrapper from 'components/atoms/QuoteFormWrapper';
import ExpansionAddButton from 'components/molecules/ExpansionAddButton';
import ExpansionSpeakerModelSelector from 'components/molecules/ExpansionSpeakerModelSelector';
import type { ComponentRegistry } from 'types/components/componentRegistry';

/**
 * Central registry of all React components available for use in modal and menu
 * configurations defined in tool constants (modals.js, views.js).
 *
 * Components are keyed by the string identifier used in the `element` field of
 * modal/menu line configs. A missing registration causes the component to render
 * nothing — add new components here before using them in tool configs.
 *
 * @example
 * // In a tool's modals.js:
 * { element: 'plainText', label: 'Hello' }
 * // Resolves to the PlainText component at render time via ComponentsIndex['plainText']
 */
export const ComponentsIndex = {
  plainText: PlainText,
  bulletList: BulletList,
  spinner: Spinner,
  textInput: TextInput,
  numberInput: NumberInput,
  doubleNumberInput: DoubleNumberInput,
  button: Button,
  unitSwitch: UnitSwitch,
  dimensionInput: DimensionInput,
  positionInput: PositionInput,
  rangeInput: RangeInput,
  selectButtons: SelectButtons,
  toggleButtons: ToggleButtons,
  toggleSelect: ToggleSelect,
  familyButtons: FamilyButtons,
  radioButtons: RadioButtons,
  tabNavigation: TabNavigation,
  measurementInput: MeasurementInput,
  slider: Slider,
  selector: MuiSelector,
  speakerMountingSelector: SpeakerMountingSelector,
  speakerLinkToggle: SpeakerLinkToggle,
  speakerModelSelector: SpeakerModelSelector,
  plotTypeSelector: PlotTypeSelector,
  checkBox: CheckBox,
  errorContent: ErrorContent,
  valueContent: ValueContent,
  carousel: MuiCarousel,
  video: MuiVideo,
  output: Output,
  fader: Fader,
  quoteForm: QuoteForm,
  quoteFormWrapper: QuoteFormWrapper,
  expansionAddButton: ExpansionAddButton,
  expansionSpeakerModelSelector: ExpansionSpeakerModelSelector,
} satisfies ComponentRegistry;
